<template>
    <div>
        <hos_apply_title title="会诊申请信息"></hos_apply_title>
        <el-form :model="form" class="mt20" label-position="left" label-width="80px" :rules="docInfoRule" ref="form" size="mini">
            <el-row>
                <el-col :span="11">
                    <el-form-item label="申请类型" prop="consultGroupType">
                        <el-select v-model="form.consultGroupType" placeholder="申请类型">
                            <el-option v-for="(item,index) in consultGroupTypes" :key="index" :label="item"
                                       :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :push="1">
                    <el-form-item label="辅助诊断类型" label-width="110px" prop="auxiliaryDiagnose">
                        <el-select v-model="form.auxiliaryDiagnose" placeholder="辅助诊断类型">
                            <el-option v-for="(item,index) in auxiliaryDiagnoses" :key="index" :label="item"
                                       :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
            <el-col :span="11">
                <el-form-item label="申请医院" prop="applyHosId">
                    <el-select v-model="form.applyHosId" placeholder="申请医院" @change="applyHosIdChange"
                               v-if="readonly===false" :disabled="isDOC">
                        <el-option v-for="(item,index) in applyHosIds" :key="index" :label="item.hosName"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input v-model="form.initHosName" v-else></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12" :push="1">
                <el-form-item label="申请科室" label-width="110px" prop="applyDeptId">
                    <el-select v-model="form.applyDeptId" placeholder="申请科室" @change="applyDeptChange"
                               v-if="readonly===false" :disabled="isDOC">
                        <el-option v-for="(item,index) in applyDeptIds" :key="index" :label="item.deptName"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input v-model="form.initDeptName" v-else></el-input>
                </el-form-item>
            </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="申请医生" prop="applyDocId">
                        <el-select v-model="form.applyDocId" placeholder="申请医生" v-if="readonly===false" @change="updatePhone" :disabled="isDOC">
                            <el-option v-for="(item,index) in applyDocIds" :key="index" :label="item.docName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.initDocName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :push="1">
                    <el-form-item label="联系方式" label-width="110px">
                        <el-input v-model="form.docPhoneNumber"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <hos_apply_title title="预约会诊医院信息" class="mt20"></hos_apply_title>
        <el-form :model="form" class="mt20" label-position="left" label-width="80px" :rules="appointmentInfoRule" ref="form2" size="mini">
            <el-row>
                <el-col :span="11">
                    <el-form-item label="会诊医院" prop="hopeHosId">
                        <el-select v-model="form.hopeHosId" placeholder="会诊医院" @change="hopeHosIdChange"
                                   v-if="readonly===false">
                            <el-option v-for="(item,index) in hopeHosIds" :key="index" :label="item.hosName"
                                       :value="item.consultGroupHosId">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.acceptHosName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :push="1">
                    <el-form-item label="会诊科室" label-width="110px" prop="hopeDeptId">
                        <el-select v-model="form.hopeDeptId" placeholder="会诊科室" @change="hopeDeptChange"
                                   v-if="readonly===false">
                            <el-option v-for="(item,index) in hopeDeptIds" :key="index" :label="item.deptName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.acceptDeptName" v-else></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="会诊医生">
                        <el-select v-model="form.hopeDocId" placeholder="会诊医生" v-if="readonly===false">
                            <el-option v-for="(item,index) in hopeDocIds" :key="index" :label="item.docName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.acceptDocName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :push="1">
                    <el-form-item label="邀请会诊时间" label-width="110px" prop="hopeTime">
                        <el-date-picker type="datetime" v-model="form.hopeTime" :editable="false" value-format="yyyy-MM-dd HH:mm" placeholder="请填写意向会诊时间"
                                        style="width: 100%" :picker-options="pickerOptions" v-if="readonly===false">
                        </el-date-picker>
                        <el-input v-model="form.hopeTime" v-else></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="18" :push="6">
                    <img src="../../assets/pay_code.png" alt="">
                </el-col>
            </el-row>
        </el-form>

        <!--<v-title title="会诊申请信息" style="margin-left: -15px"></v-title>
        <el-form ref="form" :model="form" :disabled="readonly" label-width="70px" label-position="left" size="mini">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="申请类型">
                        <el-select v-model="form.consultGroupType" placeholder="申请类型">
                            <el-option v-for="(item,index) in consultGroupTypes" :key="index" :label="item"
                                       :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="辅助诊断类型" label-width="100px">
                        <el-select v-model="form.auxiliaryDiagnose" placeholder="辅助诊断类型">
                            <el-option v-for="(item,index) in auxiliaryDiagnoses" :key="index" :label="item"
                                       :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="会诊医院">
                        <el-select v-model="form.hopeHosId" placeholder="会诊医院" @change="hopeHosIdChange"
                                   v-if="readonly===false">
                            <el-option v-for="(item,index) in hopeHosIds" :key="index" :label="item.hosName"
                                       :value="item.consultGroupHosId">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.acceptHosName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="会诊科室">
                        <el-select v-model="form.hopeDeptId" placeholder="会诊科室" @change="hopeDeptChange"
                                   v-if="readonly===false">
                            <el-option v-for="(item,index) in hopeDeptIds" :key="index" :label="item.deptName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.acceptDeptName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="会诊医生">
                        <el-select v-model="form.hopeDocId" placeholder="会诊医生" v-if="readonly===false">
                            <el-option v-for="(item,index) in hopeDocIds" :key="index" :label="item.docName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.acceptDocName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="邀请会诊时间" label-width="100px">
                        <el-date-picker type="date" v-model="form.hopeTime" value-format="yyyy-MM-dd" placeholder="选择日期"
                                        style="width: 100%" :picker-options="pickerOptions" v-if="readonly===false">
                        </el-date-picker>
                        <el-input v-model="form.hopeTime" v-else></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="申请医院">
                        <el-select v-model="form.applyHosId" placeholder="申请医院" @change="applyHosIdChange"
                                   v-if="readonly===false">
                            <el-option v-for="(item,index) in applyHosIds" :key="index" :label="item.hosName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.initHosName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="申请科室">
                        <el-select v-model="form.applyDeptId" placeholder="申请科室" @change="applyDeptChange"
                                   v-if="readonly===false">
                            <el-option v-for="(item,index) in applyDeptIds" :key="index" :label="item.deptName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.initDeptName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="申请医生">
                        <el-select v-model="form.applyDocId" placeholder="申请医生" v-if="readonly===false">
                            <el-option v-for="(item,index) in applyDocIds" :key="index" :label="item.docName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.initDocName" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="申请时间">
                        <el-input v-model="now" :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>-->
    </div>
</template>

<script>
  import VTitle from "../common/v-title";
  import {CONSULTATION_AUXILIARYDIAGNOSE, CONSULTATION_TYPE} from "../../lib/config";
  import {isEmpty, timeFormat,pickByArray} from "../../lib/utils";
  import {consultationService} from "../../lib/service/consultation";
  import {systemService} from "../../lib/service/system";
  import hos_apply_title from "../../components/hos/hos-apply-title"
  import {docInfoRule,appointmentInfoRule} from "../../lib/hos/until"

  export default {
    name: "casultation-apply-form",
    components: {hos_apply_title},
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: () => {
          return {};
        }
      },
    },
    data() {
      let data = {}, form = {};
      ['hope', 'apply'].forEach(r => {
        ['Hos', 'Dept', 'Doc'].forEach(rr => {
          data = {...data, ...{[`${r}${rr}Ids`]: []}};
          form = {...form, ...{[`${r}${rr}Id`]: ''}};
        })
      });
      return {
        ...data,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        now: timeFormat(Date.now(), '%Y-%m-%d'),
        auxiliaryDiagnoses: CONSULTATION_AUXILIARYDIAGNOSE,
        consultGroupTypes: CONSULTATION_TYPE,
        form: {
          ...form,
          hopeTime: '',
          auxiliaryDiagnose: '',
          consultGroupType: '',
            docPhoneNumber:''
        },
          docInfoRule,
          appointmentInfoRule
      }
    },
      computed:{
          isDOC(){
              return this.loginInfo.doc.docType == 'DOC'
          }
      },
    async created() {
      await this.getGroupHosList();
        const {meta, query} = this.$route;
        //是否是再次申请
        if(query.again){
            this.setAgainData();//设置缓存数据
        }
    },
    mounted() {
      this.$nextTick(() => {
        this.getApplyHosList();
      })
    },
    watch: {
      value: {
        handler(newV) {
          this.form = Object.assign({}, this.form, newV);
          this.now = timeFormat(newV.createTime, '%Y-%m-%d');
          ['Doc', 'Dept', 'Hos'].forEach(r => {
            if (isEmpty(newV[`accept${r}Name`])) {
              this.$set(this.form, `accept${r}Name`, newV[`hope${r}Name`]);
            }
          });
        }
      }
    },
    methods: {
      getForm() {
          let vail = true;
          this.$refs['form'].validate((valid) => {
              if (!valid) {
                  vail = false
                  return false;
              }
          });

          this.$refs['form2'].validate((valid) => {
              if (!valid) {
                  vail = false
                  return false;
              }
          });

        return {form:this.form,vail:vail};
      },
      async getGroupHosList() {
        this.hopeHosIds = await consultationService.groupHosList(this.docInfo.hosId);
      },
      async getApplyHosList() {
        const {doc} = this.loginInfo;
        this.applyHosIds = [
          {hosName: doc.hosName, id: doc.hosId}
        ];
        this.form.applyHosId = doc.hosId;
        this.form.applyDeptId = doc.deptId;
        await this.applyHosIdChange(doc.hosId);
        await this.applyDeptChange(doc.deptId);
          //重新申请重新赋值
          if(this.$route.query.again){
              this.form.applyDeptId=this.consultationOrder.initDeptId || '';
              this.form.applyDocId=this.consultationOrder.initDocId || '';
              this.form.docPhoneNumber=this.consultationOrder.docPhoneNumber || '';
          }
      },
      async applyHosIdChange(val) {
        this.applyDeptIds = await systemService.deptList(val);
      },
      async hopeHosIdChange(val) {
        this.hopeDeptIds = await systemService.deptList(val);
        this.form.hopeDeptId='';
        this.form.hopeDocId='';
          // const deptId = this.hopeDeptIds[0];
        // this.form.hopeDeptId = isEmpty(deptId) ? '' : deptId.id;
      },
      async applyDeptChange(val) {
        this.applyDocIds = await systemService.docList(val);
        const {doc,docPrivate} = this.loginInfo;
        if (doc.deptId === this.form.applyDeptId && doc.docType === 'DOC') {
          // this.applyDocIds.unshift({docName: doc.docName, id: doc.id});
          // const docId = this.applyDocIds[0];
          // this.form.applyDocId = isEmpty(docId) ? '' : docId.id;
            this.form.applyDocId = doc.id;
            this.form.docPhoneNumber = docPrivate.docMobile;
        }else{
            this.form.applyDocId = '';
            this.form.docPhoneNumber = '';
        }
      },
      async hopeDeptChange(val) {
        const list = await systemService.docList(val);
       // const docId = list[0];
        this.hopeDocIds = list;
        this.form.hopeDocId='';
        //this.form.hopeDocId = isEmpty(docId) ? '' : docId.id;
      },
        updatePhone(val){
            const {doc,docPrivate} = this.loginInfo;
            if (doc.deptId === this.form.applyDeptId && doc.id === val) {
                this.form.docPhoneNumber = docPrivate.docMobile;
            }else{
                this.form.docPhoneNumber = '';
            }
        },
        setAgainData(){
            const cache = this.$cache.get('consultationOrderCache');
            this.consultationOrder = {...pickByArray(cache.consultGroup, ['consultGroupType','auxiliaryDiagnose','initDeptId','initDocId','initHosId','hopeTime','acceptDeptId','acceptDocId','acceptHosId','docPhoneNumber'])}
            this.$nextTick(async () => {
                await this.hopeHosIdChange(this.consultationOrder.acceptHosId);
                await this.hopeDeptChange(this.consultationOrder.acceptDeptId);
                this.form = Object.assign({},this.form,{
                    consultGroupType:this.consultationOrder.consultGroupType,
                    auxiliaryDiagnose:this.consultationOrder.auxiliaryDiagnose,
                    applyHosId:this.consultationOrder.initHosId,
                    applyDeptId:this.consultationOrder.initDeptId,
                    applyDocId:this.consultationOrder.initDocId,
                    docPhoneNumber:this.consultationOrder.docPhoneNumber || '',
                    hopeHosId:this.consultationOrder.acceptHosId,
                    hopeDeptId:this.consultationOrder.acceptDeptId,
                    hopeDocId:this.consultationOrder.acceptDocId,
                    hopeTime:this.consultationOrder.hopeTime
                });
            })
        }
    },
  }
</script>

<style scoped lang="scss">

</style>
